import { EurekaZoneInfo } from './eureka';
import southHornMap from './southhorn.png';

// https://xivapi.com/search?indexes=Fate&filters=ID%3E=1717,ID%3C=1742&columns=Description,Name,Url

export const zoneInfoSouthHorn: EurekaZoneInfo = {
  mapImage: southHornMap,
  mapWidth: 2048,
  mapHeight: 2048,
  shortName: 'southhorn',
  hasTracker: false,
  onlyShowInactiveWithExplicitRespawns: true,
  treatNMsAsSkirmishes: true,
  mapToPixelXScalar: 50,
  mapToPixelXConstant: -50,
  mapToPixelYScalar: 50,
  mapToPixelYConstant: -50,
  fieldNotes: [
    {
      id: 8,
      name: {
        en: 'Trade Tortoise',
        de: 'Die Münzkröte',
        fr: 'Tortue à pièces',
        ja: 'コイントートス',
        cn: '金钱龟',
        ko: '동전거북',
        tc: '金錢龜',
      },
      shortName: {
        en: 'Tortoise',
        de: 'Münzkröte',
        fr: 'Tortue',
        ja: 'トートス',
        cn: '金钱龟',
        ko: '동전거북',
        tc: '金錢龜',
      },
      rarity: 0,
    },
    {
      id: 10,
      name: {
        en: 'Nymian Petalodus',
        de: 'Der nymeische Petalodus',
        fr: 'Petalodus de Nym',
        ja: 'ニーム・ペタロドゥス',
        cn: '尼姆瓣齿鲨',
        ko: '니므 페탈로두스',
        tc: '尼姆瓣齒鯊',
      },
      shortName: {
        en: 'Petalodus',
        de: 'Petalodus',
        fr: 'Petalodus',
        ja: 'ペタロドゥス',
        cn: '瓣齿鲨',
        ko: '페탈로두스',
        tc: '瓣齒鯊',
      },
      rarity: 0,
    },
    {
      id: 11,
      name: {
        en: 'Persistent Pots',
        de: 'Der Wunderpott',
        fr: 'Pots persistants',
        ja: 'おねだりポット',
        cn: '撒娇罐',
        ko: '떼쟁이 항아리',
        tc: '撒嬌罐',
      },
      shortName: {
        en: 'Pots',
        de: 'Wunderpott',
        fr: 'Pots',
        ja: 'ポット',
        cn: '撒娇罐',
        ko: '항아리',
        tc: '撒嬌罐',
      },
      rarity: 0,
    },
    {
      id: 14,
      name: {
        en: 'Mythic Idol',
        de: 'Das mystische Idol',
        fr: 'Idole mythique',
        ja: 'ミシカルアイドル',
        cn: '神秘土偶',
        ko: '신비로운 우상',
        tc: '神秘土偶',
      },
      shortName: {
        en: 'Idol',
        de: 'Idol',
        fr: 'Idole',
        ja: 'アイドル',
        cn: '土偶',
        ko: '우상',
        tc: '土偶',
      },
      rarity: 0,
    },
    {
      id: 16,
      name: {
        en: 'Black Chocobos',
        de: 'Die schwarzen Chocobos',
        fr: 'Chocobos noirs',
        ja: '黒チョコボ',
        cn: '黑陆行鸟',
        ko: '검은 초코보',
        tc: '黑陸行鳥',
      },
      shortName: {
        en: 'Chocobos',
        de: 'Chocobos',
        fr: 'Chocobos',
        ja: 'チョコボ',
        cn: '黑陆行鸟',
        ko: '검은 초코보',
        tc: '黑陸行鳥',
      },
      rarity: 0,
    },
    {
      id: 17,
      name: {
        en: 'Crescent Berserker',
        de: 'Der kreszente Berserker',
        fr: 'Berserker de Lunule',
        ja: 'クレセント・バーサーカー',
        cn: '新月狂战士',
        ko: '초승달 광전사',
        tc: '新月狂戰士',
      },
      shortName: {
        en: 'Berserker',
        de: 'Berserker',
        fr: 'Berserker',
        ja: 'バーサーカー',
        cn: '狂战士',
        ko: '광전사',
        tc: '狂戰士',
      },
      rarity: 0,
    },
    {
      id: 20,
      name: {
        en: 'Cloister Demon',
        de: 'Der Klosterdämon',
        fr: 'Démon du Cloître',
        ja: 'クロイスターデーモン',
        cn: '回廊恶魔',
        ko: '회랑 악마',
        tc: '迴廊惡魔',
      },
      shortName: {
        en: 'Cloister',
        de: 'Klosterdämon',
        fr: 'Démon',
        ja: 'デーモン',
        cn: '回廊恶魔',
        ko: '회랑 악마',
        tc: '迴廊惡魔',
      },
      rarity: 0,
    },
  ],
  nms: {
    roughwaters: {
      label: {
        en: 'Rough Waters',
        de: 'Die Wogen glätten',
        fr: 'Pas de vagues',
        ja: '波起こしの海魔「ナンム」',
        cn: '涌潮海魔——纳木',
        ko: '파도를 일으키는 바다마물',
        tc: '湧潮海魔——納木',
      },
      shortLabel: {
        en: 'Waters',
        de: 'Wogen',
        fr: 'Vagues',
        ja: 'ナンム',
        cn: '纳木',
        ko: '남무',
        tc: '納木',
      },
      x: 24.7,
      y: 35,
      fateId: 1962,
    },
    thegoldenguardian: {
      label: {
        en: 'The Golden Guardian',
        de: 'Brocken statt Barren',
        fr: 'Tombe vingt-quatre carats',
        ja: '金色の怪石「ゴールデンブロックス」',
        cn: '古代怪石——金色石碑',
        ko: '괴상한 금색 돌',
        tc: '古代怪石——金色石碑',
      },
      shortLabel: {
        en: 'Guardian',
        de: 'Brocken',
        fr: 'Carats',
        ja: 'ゴールデンブロックス',
        cn: '金色石碑',
        ko: '금빛 묘비',
        tc: '金色石碑',
      },
      x: 28.9,
      y: 31.2,
      fateId: 1963,
    },
    kingofthecrescent: {
      label: {
        en: 'King of the Crescent',
        de: 'Geißel Kreszentias',
        fr: 'La bête sadique',
        ja: '悲鳴の蒐集者「ロプロス」',
        cn: '悲鸣收集者——罗普罗斯',
        ko: '비명 수집가',
        tc: '悲鳴收集者——羅普羅斯',
      },
      shortLabel: {
        en: 'Crescent',
        de: 'Kreszentias',
        fr: 'Bête',
        ja: 'ロプロス',
        cn: '罗普罗斯',
        ko: '로프로스',
        tc: '羅普羅斯',
      },
      x: 16.9,
      y: 26.5,
      fateId: 1964,
    },
    thewingedterror: {
      label: {
        en: 'The Winged Terror',
        de: 'Dämonenvogel am Spieß',
        fr: 'Je fus zu',
        ja: '甲板の掃除人「巨大鳥」',
        cn: '甲板清扫者——巨大鸟',
        ko: '갑판 청소부',
        tc: '甲板清掃者——巨大鳥',
      },
      shortLabel: {
        en: 'Terror',
        de: 'Dämonenvogel',
        fr: 'Fus',
        ja: '巨大鳥',
        cn: '巨大鸟',
        ko: '거대 새',
        tc: '巨大鳥',
      },
      x: 10.5,
      y: 9.5,
      fateId: 1965,
    },
    anunendingduty: {
      label: {
        en: 'An Unending Duty',
        de: 'Los, Sisyphos, Donnerblitz!',
        fr: 'Pierre de tonnerre',
        ja: '神罰の石獣「シジフォス」',
        cn: '神罚石兽——西西弗斯',
        ko: '신벌의 돌짐승',
        tc: '神罰石獸——西西弗斯',
      },
      shortLabel: {
        en: 'Duty',
        de: 'Donnerblitz',
        fr: 'Pierre',
        ja: 'シジフォス',
        cn: '西西弗斯',
        ko: '시시포스',
        tc: '西西弗斯',
      },
      x: 17,
      y: 22.1,
      fateId: 1966,
    },
    braindrain: {
      label: {
        en: 'Brain Drain',
        de: 'Aspho ... asphy ... scheintot!',
        fr: 'Le poison de l\'évolution',
        ja: '進化せし怪蛇「アドバンスドエイビス」',
        cn: '进化的毒鸟——高等魔鸟',
        ko: '진화한 괴물뱀',
        tc: '進化的毒鳥——高等魔鳥',
      },
      shortLabel: {
        en: 'Brain',
        de: 'Asphy',
        fr: 'Poison',
        ja: 'アドバンスドエイビス',
        cn: '高等魔鸟',
        ko: '에이비스',
        tc: '高等魔鳥',
      },
      x: 20.5,
      y: 15,
      fateId: 1967,
    },
    adelicatebalance: {
      label: {
        en: 'A Delicate Balance',
        de: 'Kampf um Leben und Schweiß',
        fr: 'Humidité zéro',
        ja: '湿度の狩手「ディヒューミディファイア」',
        cn: '湿度猎手——除湿之火',
        ko: '습도 사냥꾼',
        tc: '濕度獵手——除濕之火',
      },
      shortLabel: {
        en: 'Balance',
        de: 'Schweiß',
        fr: 'Humidité',
        ja: 'ディヒューミディファイア',
        cn: '除湿之火',
        ko: '제습마',
        tc: '除濕之火',
      },
      x: 14,
      y: 34.4,
      fateId: 1968,
    },
    sworntosoil: {
      label: {
        en: 'Sworn to Soil',
        de: 'Kampf um Leben und Boden unter den Füßen',
        fr: 'Rester de boue',
        ja: '土壌の守り手「マッドマッド」',
        cn: '土壤守护者——癫泥怪',
        ko: '토양의 수호자',
        tc: '土壤守護者——癲泥怪',
      },
      shortLabel: {
        en: 'Soil',
        de: 'Boden',
        fr: 'Boue',
        ja: 'マッドマッド',
        cn: '癫泥怪',
        ko: '진흙광이',
        tc: '癲泥怪',
      },
      x: 9.7,
      y: 28.1,
      fateId: 1969,
    },
    apryingeye: {
      label: {
        en: 'A Prying Eye',
        de: 'Wächter des Lebens',
        fr: 'Un œil sur l\'île',
        ja: '監視の瞳「アイルオブザーバー」',
        cn: '监视之瞳——岛屿监视者',
        ko: '감시하는 눈동자',
        tc: '監視之瞳——島嶼監視者',
      },
      shortLabel: {
        en: 'Eye',
        de: 'Wächter',
        fr: 'Œil',
        ja: 'アイルオブザーバー',
        cn: '岛屿监视者',
        ko: '섬 감시자',
        tc: '島嶼監視者',
      },
      x: 20,
      y: 32.6,
      fateId: 1970,
    },
    fatalallure: {
      label: {
        en: 'Fatal Allure',
        de: 'Tückische Schönheit',
        fr: 'La belle mort',
        ja: '美しき呪殺者「イグゼクレーター」',
        cn: '美丽的咒杀者——执行者',
        ko: '아름다운 주살자',
        tc: '美麗的咒殺者——執行者',
      },
      shortLabel: {
        en: 'Allure',
        de: 'Schönheit',
        fr: 'Mort',
        ja: 'イグゼクレーター',
        cn: '执行者',
        ko: '주술마녀',
        tc: '執行者',
      },
      x: 23,
      y: 27,
      fateId: 1971,
    },
    servingdarkness: {
      label: {
        en: 'Serving Darkness',
        de: 'Seelen sammeln für den bösen Zweck',
        fr: 'Collecte mortelle',
        ja: '命の収奪者「ライフギャザラー」',
        cn: '凶恶使魔——生命收割者',
        ko: '생명을 거두어들이는 자',
        tc: '兇惡使魔——生命收割者',
      },
      shortLabel: {
        en: 'Darkness',
        de: 'Seelen',
        fr: 'Collecte',
        ja: 'ライフギャザラー',
        cn: '生命收割者',
        ko: '생명 수확자',
        tc: '生命收割者',
      },
      x: 29.7,
      y: 21.2,
      fateId: 1972,
    },
    persistentpots: {
      label: {
        en: 'Persistent Pots',
        de: 'Freude im Pott',
        fr: 'Pas de pot pour les pots',
        ja: 'しあわせのマジックポット',
        cn: '幸福的魔法罐',
        ko: '행복한 마법 항아리',
        tc: '幸福的魔法罐',
      },
      fieldNotes: 11,
      shortLabel: {
        en: 'Pots',
        de: 'Pott',
        fr: 'Pots',
        ja: 'ポット',
        cn: '魔法罐',
        ko: '항아리',
        tc: '魔法罐',
      },
      x: 25.4,
      y: 17.1,
      bunny: true,
      fateId: 1976,
    },
    pleadingpots: {
      label: {
        en: 'Pleading Pots',
        de: 'Wunder im Pott',
        fr: 'Mauvais œil pour les pots',
        ja: 'カチカチのマジックポット',
        cn: '瑟瑟发抖的魔法罐',
        ko: '고집불통 마법 항아리',
        tc: '瑟瑟發抖的魔法罐',
      },
      fieldNotes: 11,
      shortLabel: {
        en: 'Pots',
        de: 'Pott',
        fr: 'Pots',
        ja: 'ポット',
        cn: '魔法罐',
        ko: '항아리',
        tc: '魔法罐',
      },
      x: 11.8,
      y: 32,
      bunny: true,
      fateId: 1977,
    },
    /* theforkedtowerblood: {
      label: {
        en: 'The Forked Tower: Blood',
        de: 'Der Turm des Blutes',
        fr: 'Tour fourchue de la Force',
        ja: 'フォークタワー：力の塔',
        cn: '两歧塔力之塔',
        tc: '兩歧塔力之塔',
        ko: '포크 타워: 힘의 탑',
      },
      shortLabel: {
        en: 'Forked (Blood)',
        de: 'Turm (Blut)',
        fr: 'Tour (Force)',
        ja: '塔（力）',
        cn: '塔 (力)',
        tc: '塔 (力)',
        ko: '힘의 탑',
      },
      x: 22.7,
      y: 21.6,
      isCritical: true,
      ceKey: 0,
    }, */
    scourgeofthemind: {
      label: {
        en: 'Scourge of the Mind',
        de: 'Die Geißel des Geistes',
        fr: 'L\'Encéphalophage',
        ja: '脳髄愛好家「マインドフレイア」',
        cn: '脑髓爱好者——夺心魔',
        ko: '뇌수 애호가 \'정신탈취자\'',
        tc: '腦髓愛好者——奪心魔',
      },
      shortLabel: {
        en: 'Scourge',
        de: 'Geißel',
        fr: 'Scourge',
        ja: 'マインド',
        cn: '夺心魔',
        ko: '정신탈취자',
        tc: '奪心魔',
      },
      x: 27.4,
      y: 35.9,
      isCritical: true,
      ceKey: 1,
    },
    theblackregiment: {
      label: {
        en: 'The Black Regiment',
        de: 'Das schwarze Regiment',
        fr: 'Plumes d\'encre',
        ja: '黒の連隊',
        cn: '黑色连队',
        ko: '검은 연대',
        tc: '黑色連隊',
      },
      fieldNotes: 16,
      shortLabel: {
        en: 'Regiment',
        de: 'Regiment',
        fr: 'Plumes',
        ja: '連隊',
        cn: '连队',
        ko: '연대',
        tc: '連隊',
      },
      x: 30.5,
      y: 28.6,
      isCritical: true,
      ceKey: 2,
    },
    theunbridled: {
      label: {
        en: 'The Unbridled',
        de: 'Zorn auf zwei Beinen',
        fr: 'Le Rageux',
        ja: '怒れる人造人間「クレセント・バーサーカー」',
        cn: '愤怒的人造人——新月狂战士',
        ko: '분노한 인조인간 \'초승달 광전사\'',
        tc: '憤怒的人造人——新月狂戰士',
      },
      fieldNotes: 17,
      shortLabel: {
        en: 'Unbridled',
        de: 'Zorn',
        fr: 'Rageux',
        ja: 'バーサーカー',
        cn: '狂战士',
        ko: '광전사',
        tc: '狂戰士',
      },
      x: 33.8,
      y: 37.4,
      isCritical: true,
      ceKey: 3,
    },
    crawlingdeath: {
      label: {
        en: 'Crawling Death',
        de: 'Das messerscharfe Schicksal',
        fr: 'Face de griffes',
        ja: '忍び寄る爪「デスクロー」',
        cn: '潜影撕裂者——死亡爪',
        ko: '은밀히 다가오는 손톱 \'죽음손아귀\'',
        tc: '潛影撕裂者——死亡爪',
      },
      shortLabel: {
        en: 'Death',
        de: 'Schicksal',
        fr: 'Griffes',
        ja: 'デスクロー',
        cn: '死亡爪',
        ko: '죽음손아귀',
        tc: '死亡爪',
      },
      x: 35.0,
      y: 32.1,
      isCritical: true,
      ceKey: 4,
    },
    calamitybound: {
      label: {
        en: 'Calamity Bound',
        de: 'Das versiegelte Unheil',
        fr: 'Cloître à perpétuité',
        ja: '封印大妖「クロイスターデーモン」',
        cn: '挣脱封印的大妖异——回廊恶魔',
        ko: '봉인된 대요마 \'회랑 악마\'',
        tc: '掙脫封印的大妖異——迴廊惡魔',
      },
      fieldNotes: 20,
      shortLabel: {
        en: 'Calamity',
        de: 'Unheil',
        fr: 'Cloître',
        ja: 'クロイスター',
        cn: '回廊恶魔',
        ko: '회랑 악마',
        tc: '迴廊惡魔',
      },
      x: 14.6,
      y: 37.4,
      isCritical: true,
      ceKey: 5,
    },
    trialbyclaw: {
      label: {
        en: 'Trial by Claw',
        de: 'Tödliche Schönheit',
        fr: 'Écailles de cristal',
        ja: '模造されしもの「水晶竜」',
        cn: '拟造使魔——水晶龙',
        ko: '모조된 존재 \'수정룡\'',
        tc: '擬造使魔——水晶龍',
      },
      shortLabel: {
        en: 'Claw',
        de: 'Schönheit',
        fr: 'Cristal',
        ja: '水晶竜',
        cn: '水晶龙',
        ko: '수정룡',
        tc: '水晶龍',
      },
      x: 13.2,
      y: 22.9,
      isCritical: true,
      ceKey: 6,
    },
    fromtimesbygone: {
      label: {
        en: 'From Times Bygone',
        de: 'Von uralten Magien',
        fr: 'Idole surprise',
        ja: '神秘の偶像「ミシカルアイドル」',
        cn: '双极的造物——神秘土偶',
        ko: '수수께끼에 싸인 토우 \'신비로운 우상\'',
        tc: '雙極的造物——神秘土偶',
      },
      fieldNotes: 14,
      shortLabel: {
        en: 'Bygone',
        de: 'Magien',
        fr: 'Idole',
        ja: 'アイドル',
        cn: '神秘土偶',
        ko: '우상',
        tc: '神秘土偶',
      },
      x: 5.5,
      y: 26.4,
      isCritical: true,
      ceKey: 7,
    },
    companyofstone: {
      label: {
        en: 'Company of Stone',
        de: 'Die steinerne Staffel',
        fr: 'L\'Armée des argileux',
        ja: '石造りの守護騎士たち',
        cn: '石制骑士团',
        ko: '돌로 만들어진 수호 기사들',
        tc: '石製騎士團',
      },
      shortLabel: {
        en: 'Stone',
        de: 'Stein',
        fr: 'Argileux',
        ja: '守護騎士',
        cn: '骑士团',
        ko: '초승달 기사',
        tc: '騎士團',
      },
      x: 35.1,
      y: 16.2,
      isCritical: true,
      ceKey: 8,
    },
    sharkattack: {
      label: {
        en: 'Shark Attack',
        de: 'Jäger aus alten Legenden',
        fr: 'Homo selachus',
        ja: '伝説の鮫「ニーム・ペタロドゥス」',
        cn: '传说中的鲨鱼——尼姆瓣齿鲨',
        ko: '전설의 상어 \'니므 페탈로두스\'',
        tc: '傳說中的鯊魚——尼姆瓣齒鯊',
      },
      fieldNotes: 10,
      shortLabel: {
        en: 'Shark',
        de: 'Jäger',
        fr: 'Shark',
        ja: 'ペタロドゥス',
        cn: '瓣齿鲨',
        ko: '상어',
        tc: '瓣齒鯊',
      },
      x: 19.1,
      y: 4.4,
      isCritical: true,
      ceKey: 9,
    },
    onthehunt: {
      label: {
        en: 'On the Hunt',
        de: 'Gefürchtetes Gebrüll',
        fr: 'À rugir debout',
        ja: '二足の獅子「ランパントライオン」',
        cn: '双足狮人——跃立狮',
        ko: '두 발로 선 사자 \'직립 사자\'',
        tc: '雙足獅人——躍立獅',
      },
      shortLabel: {
        en: 'Hunt',
        de: 'Gebrüll',
        fr: 'Lion',
        ja: 'ライオン',
        cn: '跃立狮',
        ko: '직립 사자',
        tc: '躍立獅',
      },
      x: 34.0,
      y: 20.0,
      isCritical: true,
      ceKey: 10,
    },
    withextremeprejudice: {
      label: {
        en: 'With Extreme Prejudice',
        de: 'Mit absoluter Sicherheit',
        fr: 'Cordon de sécurité',
        ja: 'セキュリティ・コマンドー',
        cn: '防卫指令',
        ko: '보안 명령',
        tc: '防衛指令',
      },
      shortLabel: {
        en: 'Prejudice',
        de: 'Sicherheit',
        fr: 'Sécurité',
        ja: 'コマンドー',
        cn: '防卫指令',
        ko: '보안 명령',
        tc: '防衛指令',
      },
      x: 14.4,
      y: 9.3,
      isCritical: true,
      ceKey: 11,
    },
    noisecomplaint: {
      label: {
        en: 'Noise Complaint',
        de: 'Keine Gnade dem Gefieder',
        fr: 'Mammouth fâché',
        ja: '鳥嫌いの巨獣「ネオガルラ」',
        cn: '厌鸟巨兽——进化加鲁拉',
        ko: '새를 싫어하는 거대 짐승 \'네오 가루라\'',
        tc: '厭鳥巨獸——進化加魯拉',
      },
      shortLabel: {
        en: 'Complaint',
        de: 'Gefieder',
        fr: 'Mammouth',
        ja: 'ガルラ',
        cn: '加鲁拉',
        ko: '가루라',
        tc: '加魯拉',
      },
      x: 30.5,
      y: 14.1,
      isCritical: true,
      ceKey: 12,
    },
    cursedconcern: {
      label: {
        en: 'Cursed Concern',
        de: 'Das Feilschen ums Verfluchte',
        fr: 'Être aux pièces',
        ja: '呪いの商亀「コイントートス」',
        cn: '贩卖诅咒的商贩——金钱龟',
        ko: '저주를 파는 거북 \'동전거북\'',
        tc: '販賣詛咒的商販——金錢龜',
      },
      fieldNotes: 8,
      shortLabel: {
        en: 'Concern',
        de: 'Verfluchte',
        fr: 'Pièces',
        ja: 'トートス',
        cn: '金钱龟',
        ko: '동전거북',
        tc: '金錢龜',
      },
      x: 22.9,
      y: 10.6,
      isCritical: true,
      ceKey: 13,
    },
    eternalwatch: {
      label: {
        en: 'Eternal Watch',
        de: 'Ausgebessert und verbessert',
        fr: 'Comme un lion nouveau',
        ja: '復元された獅子像「リペアドライオン」',
        cn: '城塞守卫——复原狮像',
        ko: '오래된 사자상 \'복원된 사자\'',
        tc: '城塞守衛——復原獅像',
      },
      shortLabel: {
        en: 'Watch',
        de: 'Wacht',
        fr: 'Lion',
        ja: 'ライオン',
        cn: '复原狮像',
        ko: '복원된 사자',
        tc: '復原獅像',
      },
      x: 38.9,
      y: 25.1,
      isCritical: true,
      ceKey: 14,
    },
    flameofdusk: {
      label: {
        en: 'Flame of Dusk',
        de: 'Das finsterste Feuer',
        fr: 'Les ailes de pierre',
        ja: '昏き篝火「ヒンキーパンク」',
        cn: '昏暗妖魂——鬼火苗',
        ko: '어둑한 화톳불 \'힝키펑크\'',
        tc: '昏暗妖魂——鬼火苗',
      },
      shortLabel: {
        en: 'Dusk',
        de: 'Feuer',
        fr: 'Pierre',
        ja: 'ヒンキー',
        cn: '鬼火苗',
        ko: '힝키펑크',
        tc: '鬼火苗',
      },
      x: 10.1,
      y: 18.3,
      isCritical: true,
      ceKey: 15,
    },
  },
};
